import classnames from 'classnames';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { FaLightbulb } from 'react-icons/fa';

import { Service } from '@/types/service';
import { isJa } from '@/settings/i18n';
import styled from 'styled-components';
import { pages } from '@/settings/pages';
import { SERVICE_GROUP_ID } from '@/constants';
import { Label } from '@/components/shared/Label';

import { Checkboxes } from '../Checkboxes';
import { RadioButtons } from '../RadioButtons';

export type Props = {
  value: number[];
  refillServiceIds: (serviceId: number) => void;
  pushServiceIds: (serviceId: number) => void;
  pruneServiceIds: (serviceId: number) => void;
  serviceGroupId: number | null;
  error?: string | (string | undefined)[];
  services: Service[];
};

export const Services: React.FC<Props> = ({
  value = [],
  error = '',
  serviceGroupId,
  pushServiceIds,
  pruneServiceIds,
  refillServiceIds,
  services,
}) => {
  const { t } = useTranslation();

  return (
    <Styled>
      <div
        id="serviceIds"
        className={classnames('field', 'service-field', { error })}
      >
        {(() => {
          switch (serviceGroupId) {
            case 1:
            case 3:
            case 7:
              // hodai or hodaiPlus, Unlimited
              return (
                <>
                  <label>{t('models.subscription.term')}</label>
                  <RadioButtons
                    selected={value[0]}
                    list={services}
                    onChange={(id, checked) => {
                      if (checked) {
                        refillServiceIds(id);
                      }
                    }}
                  />
                </>
              );
            case 2:
              return (
                <>
                  <label>{t('models.subscription.subject')}</label>
                  <Checkboxes
                    values={value}
                    list={services}
                    onChange={(id, checked) => {
                      if (checked) {
                        pushServiceIds(id);
                      } else {
                        pruneServiceIds(id);
                      }
                    }}
                  />
                </>
              );
            default:
              return null;
          }
        })()}
        {(() => {
          switch (serviceGroupId) {
            // hodaiPlus
            case 3:
              return (
                <div>
                  <div className="hint">
                    <FaLightbulb className="icon" />
                    <span>
                      <Trans i18nKey="ui.subscription.toHodaiPlusUsersHint"></Trans>
                    </span>
                  </div>
                  {!isJa() && (
                    <div className="hint">
                      <FaLightbulb className="icon" />
                      <span>
                        <Trans i18nKey="ui.subscription.toUnlimitedApplyLinkHint">
                          <a
                            href={pages.service.detail.replace(
                              ':id',
                              SERVICE_GROUP_ID.gu.toString(),
                            )}
                          ></a>
                        </Trans>
                      </span>
                    </div>
                  )}
                </div>
              );
            default:
              return null;
          }
        })()}
        {error && <Label>{error}</Label>}
      </div>
    </Styled>
  );
};

const Styled = styled.div`
  .hint {
    position: relative;
    padding-left: 20px;
    .icon {
      position: absolute;
      top: 3px;
      left: 0;
    }
  }
`;
